const BLOCK_ELEMENTS:Array<string> = [
  'address',
  'article',
  'aside',
  'blockquote',
  'canvas',
  'dd',
  'div',
  'dl',
  'dt',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'header',
  'hr',
  'li',
  'main',
  'nav',
  'noscript',
  'ol',
  'p',
  'pre',
  'section',
  'table',
  'tfoot',
  'ul',
  'video',
];

const INLINE_ELEMENTS:Array<string> = [
  'a',
  'abbr',
  'acronym',
  'b',
  'bdo',
  'big',
  'br',
  'button',
  'cite',
  'code',
  'dfn',
  'em',
  'i',
  'img',
  'input',
  'kbd',
  'label',
  'map',
  'object',
  'output',
  'q',
  'samp',
  'script',
  'select',
  'small',
  'span',
  'strong',
  'sub',
  'sup',
  'textarea',
  'time',
  'tt',
  'var',
];

const ANCHOR_ALLOWED_CHILDREN:Array<string> = [
  'Abierto',
  'Ahorro',
  'AhorroMovil',
  'Ajustes',
  'Alerta',
  'AMC',
  'AnadirMas',
  'Apagar',
  'ArrowLeftRight',
  'AtClientes',
  'Aura',
  'Auriculares',
  'Ayuda',
  'AyudaPregunta',
  'BBDD',
  'Blog',
  'Bombilla',
  'Buscar',
  'Calendario',
  'CalidadDeServicio',
  'CallCenter',
  'CalleTrece',
  'Campana',
  'CanalCero',
  'CasaSegura',
  'Cerrar',
  'Chat',
  'Cheuron',
  'CircleCheuron',
  'Cine',
  'CineIcon',
  'CineN',
  'CineRock',
  'ClaveWifi',
  'Clic',
  'Cloud',
  'Comedia',
  'ComedyCentral',
  'Compartir',
  'Comprar',
  'ComprarDatos',
  'CompraSegura',
  'ComprarPlanes',
  'ConfianzaOnline',
  'Configuracion',
  'ConfiguracionCorreo',
  'ConfiguracionRouter',
  'ConfigurarMovil',
  'ConsultaCanjes',
  'ConsultaDocumento',
  'Consumo',
  'CorazonSalud',
  'Dark',
  'Datos',
  'Deporte',
  'Deporte1',
  'Deporte2',
  'DeporteIcon',
  'Descargar',
  'DescargarApp',
  'Desco',
  'DescoMando',
  'DetalleLlamadas',
  'Dialogando',
  'Dinero',
  'Directorio',
  'Disney',
  'Documento',
  'Ecologico',
  'Envio',
  'Error',
  'Estrenos',
  'Euro',
  'EuroCirculo',
  'Eurosport',
  'Facebook',
  'Factura',
  'Favorito',
  'Fibra',
  'Fijo',
  'FijoInternet',
  'Filtro',
  'Formula1',
  'Foro',
  'Fox',
  'FoxLife',
  'FundacionTelefonica',
  'Fusion',
  'Futbol',
  'FutbolIcon',
  'Grabar',
  'Global',
  'Golf',
  'Hgu',
  'Home',
  'HomeDoor',
  'Hollywood',
  'Informacion',
  'Instagram',
  'Internet',
  'InternetMovil',
  'Juego',
  'Lanzamiento',
  'LaLiga',
  'LigaCampeones',
  'LineaAdicional',
  'Linkedin',
  'LlamadaEntrante',
  'LlamadaEspera',
  'LlamadaSaliente',
  'Mas80',
  'MeGusta',
  'MensDictados',
  'MisPedidos',
  'Motor',
  'MotorIcon',
  'Movil',
  'Movistar',
  'MovistarCar',
  'MovistarCircular',
  'MovistarLikes',
  'MovistarPlus',
  'MpaUp',
  'Multicontenido',
  'Multipantalla',
  'NoVer',
  'Noticias',
  'Nube',
  'Nubico',
  'Oferta',
  'OfertasExclusivas',
  'Ok',
  'Ont',
  'Opciones',
  'PagarFacturas',
  'PagoOnline',
  'Partidazo',
  'Perfil',
  'Play',
  'Portatil',
  'PriorityUser',
  'Producto',
  'Qustodio',
  'RealMadrid',
  'RechazoLlamada',
  'Reloj',
  'Router',
  'Seguridad',
  'SeguridadAbierta',
  'SeguroMovil',
  'Series',
  'SeriesExtras',
  'SeriesIcon',
  'SeriesMania',
  'ServicioTecnicoMovil',
  'Sim',
  'SinConexion',
  'Sms',
  'SoporteTecnico',
  'Star',
  'SundanceTv',
  'SYFY',
  'TarjetaCredito',
  'TaquillaUp',
  'TCM',
  'Telefonica',
  'TelefonicaFanshop',
  'Tiendas',
  'Tokens',
  'Tuenti',
  'Tv',
  'Twitter',
  'Ubicacion',
  'UHD',
  'Usuario',
  'U7D',
  'Vamos',
  'Ver',
  'Video',
  'ViolenciaDeGenero',
  'WhatsappBlue',
  'WhatsappGreen',
  'Xtra',
  'Youtube',
  'b',
  'i',
  'span',
  'strong',
  'sub',
  'sup',
  'svg',
  'SvgIcon',
  'SvgIconLoader',
  'SvgIconLabel',
  'TextInfo',
  'Notification',
  'button',
];

export const checkIfIsItAString = (input:string):string => {
  let inputRes:string = '';
  if (input && typeof input === 'string') {
    inputRes = input;
  }
  return inputRes;
}

export const isInlineElement = (tagType:string):boolean => {
  const myTagType = checkIfIsItAString(tagType);
  const tagType2Cmp = myTagType.toLowerCase();
  const founded = INLINE_ELEMENTS.find((element) => {
    const element2Cmp = element.toLowerCase();
    return element2Cmp === tagType2Cmp
  });
  return (!!founded);
}

export const isBlockElement = (tagType:string):boolean => {
  const myTagType = checkIfIsItAString(tagType);
  const tagType2Cmp = myTagType.toLowerCase();
  const founded = BLOCK_ELEMENTS.find((element) => {
    const element2Cmp = element.toLowerCase();
    return element2Cmp === tagType2Cmp
  });
  return (!!founded);
}

export const isAnchorAllowedChild = (tagType:string):boolean => {
  const myTagType = checkIfIsItAString(tagType);
  const tagType2Cmp = myTagType.toLowerCase();
  const founded = ANCHOR_ALLOWED_CHILDREN.find((element) => {
    const element2Cmp = element.toLowerCase();
    return element2Cmp === tagType2Cmp
  });

  return (!!founded);
}
